import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-copy",
  "use": "icon-copy-usage",
  "viewBox": "0 0 23.001 24.3",
  "content": "<symbol viewBox=\"0 0 23.001 24.3\" id=\"icon-copy\"><path d=\"M1.793 23.794A1.294 1.294 0 0 1 .5 22.5V5.675a1.29 1.29 0 0 1 1.293-1.293h15.53a1.29 1.29 0 0 1 1.293 1.293V22.5a1.293 1.293 0 0 1-1.293 1.3Zm.647-1.941h14.234V6.325H2.44Zm18.116-2.263V2.442H7.941a.972.972 0 0 1 0-1.942h13.588a.98.98 0 0 1 .971.978v18.111a.972.972 0 1 1-1.942 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol